import React, { Component } from 'react';
import API from '../api.js';
import Tools from '../tools';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setLoginData } from '../actions/actions';
import '../css/login.css';

class Login extends Component {

	constructor() {
		super();
		Tools.init();
		API.init(this);

		//TODO: try auto-login if ac, tk exsit in cookie


		// this.login();
		this.state = {
			ac: "",
			pw: ""
		};
		this.onAcChange = this.onAcChange.bind(this);
		this.onPwChange = this.onPwChange.bind(this);
		this.renderForm = this.renderForm.bind(this);
		this.login = this.login.bind(this);
	}

	login(e) {
		e.stopPropagation();
		e.preventDefault();
		// console.log(this.state);
		const { ac, pw } = this.state;
		this.onAcChange = this.onAcChange.bind(this);

		API.Login(ac, pw)
			.then(data => {
				console.log(API.first_page, data);

				if (!data || !data.code
					|| (22040 != data.code && 22042 != data.code)
				) {
					//error
					alert("請確認帳密");
				} else {
					setTimeout(() => {
						this.props.history.push(API.first_page);
					}, 100)
				}
			}) // JSON from `response.json()` call
			.catch(error => console.error(error))

		// API.Login(ac, pw
		// 	, function (data) {
		// 		// window.location.href = API.first_page;
		// 		console.log(API.first_page);
		// 		this.props.history.push(API.first_page);
		// 	}.bind(this), function (ac, tk) {
		// 		this.props.setLoginData(ac, tk)
		// 		// alert( $.i18n.get("login-failMsg") );
		// 	}.bind(this));
	}

	onAcChange(e) {
		this.setState({ ac: e.target.value });
	}

	onPwChange(e) {
		this.setState({ pw: e.target.value });
	}


	// onClickRegister(e) {
	// 	this.props.history.push(API.signup_page);
	// }

	renderForm() {
		const { ac, pw } = this.state;
		const { onAcChange, onPwChange, login } = this;

		return (
			<>
				{/* <Col md={12}>
					<h1 className="text-border-white">EZChoice</h1>
				</Col> */}
				<h2 className="mb-5 text-center">9EZ!雲端智慧調查平台</h2>
				<Form>
					<Form.Group controlId="formGroupLogin">
						{/* <Form.Label column>使用者帳號</Form.Label> */}
						<Col>
							{/* <input onChange={onAcChange} type="email" className="form-control" id="staticEmail" value={ac} placeholder="" /> */}
							<Form.Control type="email" placeholder="ID" onChange={onAcChange} value={ac} />
						</Col>
					</Form.Group>
					<Form.Group controlId="formGroupPwd">
						{/* <Form.Label column>登入密碼</Form.Label> */}
						<Col>
							{/* <input onChange={onPwChange} type="password" className="form-control" id="inputPassword" value={pw} placeholder="" /> */}
							<Form.Control type="password" placeholder="密碼(8~20個英數混合字元)" onChange={onPwChange} value={pw} />
						</Col>
					</Form.Group>
					<Form.Group controlId="formGroupBtns">
						<Col xs={12} className="text-center">
							<Button className="w-100" variant="link" href={"/#forget"}>忘記密碼</Button>
						</Col>
					</Form.Group>
					<Form.Group controlId="formGroupBtns">
						<Col xs={12} className="text-center">
							<Button className="w-100" variant="primary" onClick={login}>確認</Button>
						</Col>
					</Form.Group>
					<hr />
					<Form.Group controlId="formGroupBtns">
						<Col xs={12} className="text-center">
							<Button className="w-100" variant="info" href={"/#signup"}>註冊新帳號</Button>
						</Col>
					</Form.Group>
				</Form>
			</>
		)
	}

	render() {
		const { renderForm } = this;

		return (
			<div id="login" className="App">
				<div id="main-content">
					<Container className="h-100">
						<Row className="justify-content-center h-100">
							<Col className="my-auto col-10 col-md-8 col-lg-6">
								{renderForm()}
							</Col>
							{/* <Col className="d-display d-sm-none fixed-bottom mb-2">
								{renderForm()}
							</Col>
							<Col className="d-none d-sm-block my-auto col-6 ">
								{renderForm()}
							</Col> */}
						</Row>
					</Container>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	ac: state.authReducer.ac,
	tk: state.authReducer.tk
})

const mapDispatchToProps = {
	setLoginData: setLoginData
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Login)
// export default Login;
